/* CGS Racing Drops — interactions (countdown, panier, tailles, reveal)
   Conçu pour le thème Concept (OS 2.0). Aucune dépendance externe. */
(function () {
  'use strict';

  /* ---------- Compte à rebours ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-cgs-countdown]').forEach(function (root) {
      if (root.dataset.cgsBound) return; root.dataset.cgsBound = '1';
      var target = new Date(root.getAttribute('data-cgs-countdown')).getTime();
      if (isNaN(target)) return;
      var elD = root.querySelector('[data-cd-d]');
      var elH = root.querySelector('[data-cd-h]');
      var elM = root.querySelector('[data-cd-m]');
      var elS = root.querySelector('[data-cd-s]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var d = Math.max(0, target - Date.now());
        var dd = Math.floor(d / 86400000); d -= dd * 86400000;
        var hh = Math.floor(d / 3600000); d -= hh * 3600000;
        var mm = Math.floor(d / 60000); d -= mm * 60000;
        var ss = Math.floor(d / 1000);
        if (elD) elD.textContent = pad(dd);
        if (elH) elH.textContent = pad(hh);
        if (elM) elM.textContent = pad(mm);
        if (elS) elS.textContent = pad(ss);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Reveal au scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.cgs-rd .reveal-up');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Sélection de taille ---------- */
  function initSizes() {
    document.querySelectorAll('.cgs-rd [data-cgs-product]').forEach(function (card) {
      if (card.dataset.cgsSzBound) return; card.dataset.cgsSzBound = '1';
      var btns = card.querySelectorAll('.b-sz button, .sizes button');
      btns.forEach(function (b) {
        if (b.classList.contains('so')) return;
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          var vid = b.getAttribute('data-variant-id');
          if (vid) card.setAttribute('data-selected-variant', vid);
        });
      });
    });
    // recto/verso thumbs (preview statique)
    document.querySelectorAll('.cgs-rd .thumbs i').forEach(function (t) {
      if (t.dataset.cgsBound) return; t.dataset.cgsBound = '1';
      t.addEventListener('click', function () {
        var p = t.parentElement;
        p.querySelectorAll('i').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });
  }

  /* ---------- Panier (tiroir Concept) ---------- */
  function cartDrawer() { return document.querySelector('cart-drawer'); }

  function openDrawer() {
    var cd = cartDrawer();
    if (cd && typeof cd.show === 'function') { cd.show(); return true; }
    return false;
  }

  function refreshDrawer() {
    var cd = cartDrawer();
    if (!cd) return Promise.resolve(false);
    var wrap = cd.closest('[id^="shopify-section-"]');
    if (!wrap) return Promise.resolve(false);
    var sectionId = wrap.id.replace('shopify-section-', '');
    return fetch('/?sections=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var fresh = data[sectionId];
        if (!fresh) return false;
        var tmp = document.createElement('div');
        tmp.innerHTML = fresh;
        var newWrap = tmp.querySelector('#' + CSS.escape(wrap.id)) || tmp.firstElementChild;
        if (newWrap) { wrap.innerHTML = newWrap.innerHTML; return true; }
        return false;
      })
      .catch(function () { return false; });
  }

  function flashBtn(btn, text) {
    if (!btn) return;
    var roll = btn.querySelector('.b-roll');
    var original = btn.getAttribute('data-label') || (roll ? roll.textContent : btn.textContent);
    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', original);
    btn.classList.add('is-loading');
  }
  function unflash(btn) { if (btn) btn.classList.remove('is-loading'); }

  function addVariant(variantId, qty, btn) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body && res.body.description || 'Ajout impossible'); }
        return refreshDrawer().then(function () { openDrawer() || (window.location.href = '/cart'); });
      });
  }

  function initAddToCart() {
    document.querySelectorAll('.cgs-rd [data-cgs-add]').forEach(function (btn) {
      if (btn.dataset.cgsBound) return; btn.dataset.cgsBound = '1';
      btn.addEventListener('click', function (e) {
        var card = btn.closest('[data-cgs-product]');
        if (!card) return;
        // fallback : pas de produit branché -> lien
        if (card.getAttribute('data-cgs-mode') !== 'product') {
          var url = btn.getAttribute('data-fallback-url');
          if (url) window.location.href = url;
          return;
        }
        e.preventDefault();
        var vid = card.getAttribute('data-selected-variant');
        if (!vid) {
          var def = card.querySelector('.b-sz button.on[data-variant-id], .sizes button.on[data-variant-id]')
            || card.querySelector('.b-sz button[data-variant-id]:not(.so), .sizes button[data-variant-id]:not(.so)');
          vid = def ? def.getAttribute('data-variant-id') : null;
        }
        if (!vid) { alert('Choisis une taille.'); return; }
        flashBtn(btn);
        addVariant(vid, 1, btn)
          .catch(function (err) { alert(err.message || 'Erreur panier'); })
          .then(function () { unflash(btn); });
      });
    });
  }

  function initCartButtons() {
    document.querySelectorAll('.cgs-rd [data-cgs-cart]').forEach(function (b) {
      if (b.dataset.cgsBound) return; b.dataset.cgsBound = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (!openDrawer()) window.location.href = '/cart';
      });
    });
  }

  function init() {
    initCountdowns();
    initReveal();
    initSizes();
    initAddToCart();
    initCartButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Re-init dans l'éditeur de thème Shopify (section rechargée)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.cgs-rd')) init();
  });
})();
